const { isArray } = Array;

export { isArray };
